import { ResellerConfigModel } from '../reseller-config.model';

export const ResellerConfig: ResellerConfigModel = {
  'ap-south-1': {
    userPoolId: 'ap-south-1_nuVt8XnKS',
    userPoolClientId: '7vm9ocg9pkunt5qr3scqtbjbpp',
  },
  'ap-southeast-2': {
    userPoolId: 'ap-southeast-2_AYH7fgoUB',
    userPoolClientId: '449cb62m4045vkl1m9r2883r7s',
  },
  'eu-central-1': {
    userPoolId: 'eu-central-1_Te9iw8Un4',
    userPoolClientId: '3boe745d4r7ihav9jmo78oeuqd',
  },
  'us-east-1': {
    userPoolId: 'us-east-1_3hs3pFggz',
    userPoolClientId: '5v0j4robgbkm836tuoqej76gs7',
  },
  'eu-west-2': {
    userPoolId: 'eu-west-2_B5TPBSlqL',
    userPoolClientId: '4cj9lmdbj89nq1i4jjqeqleec4',
  },
  'me-south-1': {
    userPoolId: 'me-south-1_royDy6Rpx',
    userPoolClientId: '4ihgmg7pvfmu2lnepsil33kfer',
  },
  'sa-east-1': {
    userPoolId: 'sa-east-1_LmluCmv7I',
    userPoolClientId: 'mq722jtgn9d7vbc8mip0q9ipv',
  },
};
